import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../NavigationContainer.vue";
import InquiryNavigation from "../../InquiryNavigationContainer.vue";
import InquiryLinkNavigation from "../../InquiryLinkNavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import InquiryInfoDataService from "@/services/InquiryInfoDataService";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading";
import Alert from "@/components/scan/parts/Alert.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const inquiryInfo = reactive([]);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("Contact Information");
const getData = ref(false);

onMounted(function () {
  isLoading.value = true;
  getInquiryInfo();
});

const getInquiryInfo = () => {
  isLoading.value = true;

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // get Inquiry Information
  InquiryInfoDataService.getInquiryInfo()
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        for (let info of response.data) {
          inquiryInfo.push(info);
        }
      }
      getData.value = true;
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err011");
      alertState.value = "error";
      isLoading.value = false;
    });
};

onUpdated(function () {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tbltbodyinquiry")?.clientHeight;
    if (dataHeight != 0) {
      var mydivh = document.getElementById("inquiryDiv")?.clientHeight;
      tableHeight = (mydivh * 93) / 100 - 43;
      document.getElementById("tblInquirydiv").style.height =
        tableHeight + "px";
      if (dataHeight > tableHeight) {
        document.getElementById("tblInquirydiv").style.width = "100%";
      } else {
        document.getElementById("tblInquirydiv").style.width =
          "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
  isLoading.value = false;
});

const __returned__ = { isLoading, inquiryInfo, alertMessage, alertState, i18n, title, getData, getInquiryInfo, Navigation, InquiryNavigation, InquiryLinkNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})